// removed by extract-text-webpack-plugin
module.exports = {"container":"styles__container__dypgE","p":"styles__p__1O2kG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ProductFAQ/styles.scss
// module id = 406
// module chunks = 0